<template>
    <v-card flat>
        <v-row class="hidden-sm-and-down">
            <v-col cols="12" sm="6" class="pr-0">
                <v-card-title class="d-flex title justify-center pa-0">{{ $t('condition') }}</v-card-title>
            </v-col>
            <v-col cols="12" sm="6" class="pr-0">
                <v-card-title class="d-flex title justify-center pa-0">{{ $t('discount') }} (%)</v-card-title>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <div  v-for="i in conditionsCount" :key="i">
            <v-divider v-if="conditionsCount > 1"></v-divider>
            <v-row>
                <v-col cols="12" sm="12" class="pr-0 pt-6">
                    <v-form v-model="validated">
                        <v-row class="d-flex">
                            <v-col cols="12" sm="6" class="px-10 pa-sm-0 d-flex">
                                <div class="d-flex justify-center flex-wrap flex-sm-nowrap">
                                    <v-text-field
                                            @input="itemChange(i)"
                                            v-model="amountPolicy[i - 1].minSum"
                                            :label="$t('fromOt')"
                                            class="pa-0 ma-0 px-sm-4"
                                            color="orange lighten-2"
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                    <v-text-field
                                            @input="itemChange"
                                            v-model="amountPolicy[i - 1].maxSum"
                                            :label="$t('before')"
                                            class="pa-0 ma-0 pr-4"
                                            color="orange lighten-2"
                                            type="number"
                                            min="1"
                                    ></v-text-field>
                                    <v-autocomplete
                                            @input="itemChange"
                                            v-model="amountPolicy[i - 1].currency"
                                            :items="currencies"
                                            clearable
                                            :label="$t('currency')"
                                            hide-no-data
                                            item-text="name"
                                            item-value="id"
                                            cache-items
                                            color="orange lighten-2"
                                            class="pa-0 ma-0"
                                            :rules="rules"
                                    ></v-autocomplete>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="px-10 py-sm-0">
                                <v-row class="d-flex justify-center">
                                    <v-col cols="12" sm="3" class="px-4 pa-sm-0">
                                        <v-text-field
                                                @input="itemChange"
                                                v-model="amountPolicy[i - 1].discount"
                                                :label="$t('discount') + ' '+ '(%)'"
                                                class="pa-0 ma-0"
                                                color="orange lighten-2"
                                                :rules="rules"
                                                type="number"
                                                min="1"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
            <div class="d-flex justify-center pb-4">
                <v-btn
                        dark
                        class="text--main-yellow"
                        text
                        @click="addString"
                        v-if="conditionsCount === i"
                >
                    {{ $t('addCondition') }}
                </v-btn>
                <v-btn
                        v-if="conditionsCount > 1"
                        text
                        color="error"
                        @click="deleteString(i - 1)"
                >
                    {{ $t('delete') }}
                </v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>

    export default {
        name: "PurchaseAmount",
        props: ['initialAmountPolicy', 'currenciesData'],
        data() {
            return {
                validated: false,
                rules: [value => !!value || this.$t('requiredField')],
                conditionsCount: 1,
                amountPolicy: [],
                currencies: [],
            }
        },
        methods: {
            addString() {
                this.amountPolicy.push(this.getDefaultPolicy());
                this.conditionsCount++;
            },
            deleteString(i) {
                this.conditionsCount--;
                this.amountPolicy.splice(i,1);
                this.itemChange(i);
            },
            itemChange() {
                const data = [];
                let isValid = true;

                this.amountPolicy.forEach(item => {
                    if(this.validate(item))  {
                        data.push(item);
                    } else {
                        isValid = false;
                    }
                });
                this.$emit('list-change', {data, isValid});
            },
            getDefaultPolicy() {
                return {
                    minSum: null,
                    maxSum: null,
                    currency: null,
                    discount: null,
                }
            },
            validate(policy) {
                let valid = false;
                if(policy.minSum || policy.maxSum) {
                    valid = true;
                }
                if(!policy.discount || !policy.currency) {
                    valid = false;
                }
                return valid;
            }
        },
        beforeMount() {
            this.amountPolicy.push(this.getDefaultPolicy());
        },
        watch: {
            initialAmountPolicy: {
                handler() {
                    if(this.initialAmountPolicy.length) {
                        this.amountPolicy = this.initialAmountPolicy;
                        this.conditionsCount = this.initialAmountPolicy.length;
                    }
                },
                deep: true
            },
            currenciesData: {
                handler() {
                    this.currencies = this.currenciesData;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
